const EXECUTE = 'Execute';
const SKIP = 'Skip';
const INFORMATIONAL = 'Informational';

export {
    EXECUTE,
    SKIP,
    INFORMATIONAL
}